import { useEffect, useState, useRef } from 'react';

const applyDefaultWidth = () => {
	const editorScrollParent: HTMLElement | null = document.querySelector(
		'.fabric-editor-popup-scroll-parent',
	);
	if (editorScrollParent) {
		return editorScrollParent.clientWidth || 0;
	}
	return 0;
};

export const useEditorWidthObserver = ({
	isFixedWidth = false,
}: {
	isFixedWidth?: boolean;
}): {
	width: any;
	observerRef: ResizeObserver | null;
} => {
	const defaultWidth = applyDefaultWidth();
	const [width, setWidth] = useState<any>(defaultWidth);
	const observerRef = useRef<ResizeObserver | null>(null);

	useEffect(() => {
		const editorScrollParent: HTMLElement | null = document.querySelector(
			'.fabric-editor-popup-scroll-parent',
		);
		if (editorScrollParent && !isFixedWidth) {
			observerRef.current = new ResizeObserver((entries) => {
				setWidth(Math.floor(entries[0]?.target.clientWidth));
			});
			observerRef.current.observe(editorScrollParent);

			return () => observerRef?.current?.disconnect();
		}
	}, [observerRef, isFixedWidth]);

	return {
		width,
		observerRef: observerRef.current,
	};
};
